import { Button } from '@material-ui/core';
import React from 'react';
import { Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { FontAwesome } from '..';

interface FooterProps {
  id: string;
}
const FooterForm: React.FC<FooterProps> = ({ id }) => {
  const history = useHistory();

  return (
    <Row className="container-buttons justify-content-between mt-4" noGutters>
      <Button
        className="primary-button outline"
        onClick={() => history.goBack()}
      >
        Cancelar
      </Button>

      <Button type="submit" className="btn primary-button">
        {id ? 'Editar' : 'Salvar'}
      </Button>
    </Row>
  );
};

export default FooterForm;
